export default __webpack_public_path__ + "static/media/close-options-razon-modal.2ebaf6c4.svg";